const msToSeconds = (durationInMS: number): number => {
  return durationInMS / 1000;
};

export { msToSeconds };
